<template>
  <div class="flex-1 flex flex-col overflow-hidden" @click="setCalendarMainShow">
    <Header :title="showLang[selectLang]['views']['Report']['page_name']" @childLang="useLang" @toggleSidebar="$emit('toggleSidebar')">
      <div class="d2-header-label">
        {{showTiktokLang[selectLang]['views']['Report']['advertising_source']}}
      </div>
      <div class="mx-1">
        <Dropdown
          v-model="fromAccountSelect"
          optionLabel="name"
          optionValue="code"
          :options="fromAccountOptions"
          :placeholder="showLang[selectLang]['views']['Report']['advertise_account_placeholder_text']"
          appendTo="body"
          class="w-36 ml-2s rounded-md"
          :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
        >
          <template #value="slotProps">
            <div v-if="slotProps.value" class="flex align-items-center">
              <img v-if="slotProps.value == 'facebook'" :alt="slotProps.value" width="28" src="https://private.autoturn.net/img/facebook_icon.png"/>
              <img v-if="slotProps.value == 'tiktok'" class="mt-0.5 mr-0.5 mb-0.5" :alt="slotProps.value" width="25" src="https://private.autoturn.net/img/tiktok_icon.png"/>
              <div v-if="slotProps.value == 'facebook'" class="leading-7">Facebook</div>
              <div v-if="slotProps.value == 'tiktok'" class="leading-7">Tiktok</div>
            </div>
            <span v-else>
                {{ slotProps.placeholder }}
            </span>
          </template>
          <template #option="slotProps">
            <div class="flex align-items-center">
              <img v-if="slotProps.option.code == 'facebook'" class="-ml-0.5" :alt="slotProps.option.name" width="28" src="https://private.autoturn.net/img/facebook_icon.png"/>
              <img v-if="slotProps.option.code == 'tiktok'" class="mt-0.5 mr-0.5 mb-0.5" :alt="slotProps.option.name" width="25" src="https://private.autoturn.net/img/tiktok_icon.png"/>
              <div class="leading-7">{{ slotProps.option.name }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
      <div v-if="dataType == 'facebook'" class="d2-header-label">
        {{showLang[selectLang]['views']['Report']['advertise_account_text']}}
      </div>
      <div v-if="dataType == 'facebook'" class="mx-1">
        <Dropdown
          v-model="accountSelect"
          optionLabel="name"
          optionValue="code"
          :options="accountOptions"
          :placeholder="showLang[selectLang]['views']['Report']['advertise_account_placeholder_text']"
          appendTo="body"
          class="w-52 ml-2s rounded-md leading-8"
          :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
          filter
          @change="adaccount(accountSelect)"
        />
      </div>
      <div v-if="dataType == 'facebook'" class="d2-header-label">
        {{showLang[selectLang]['views']['Report']['campaign_text']}}
      </div>
      <div v-if="dataType == 'facebook'" class="mx-1">
        <Dropdown
          v-model="eventSelect"
          optionLabel="name"
          optionValue="code"
          :options="eventOptions"
          :placeholder="showLang[selectLang]['views']['Report']['campaign_placeholder_text']"
          appendTo="body"
          class="w-52 ml-2s rounded-md leading-8"
          :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
          filter
          @change="campaign(eventSelect)"
        />
      </div>

      <div v-if="dataType == 'tiktok'" class="d2-header-label">
        {{showTiktokLang[selectLang]['views']['Report']['account_name']}}
      </div>
      <div v-if="dataType == 'tiktok'" class="mx-1">
        <Dropdown
          v-model="accountSelect"
          optionLabel="name"
          optionValue="code"
          :options="accountOptions"
          :placeholder="showLang[selectLang]['views']['Report']['advertise_account_placeholder_text']"
          appendTo="body"
          class="w-52 ml-2s rounded-md leading-8"
          :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
          filter
          @change="adaccount(accountSelect)"
        />
      </div>
      <div v-if="dataType == 'tiktok'" class="d2-header-label">
        {{showTiktokLang[selectLang]['views']['Report']['promotion_series']}}
      </div>
      <div v-if="dataType == 'tiktok'" class="mx-1">
        <Dropdown
          v-model="eventSelect"
          optionLabel="name"
          optionValue="code"
          :options="eventOptions"
          :placeholder="showLang[selectLang]['views']['Report']['campaign_placeholder_text']"
          appendTo="body"
          class="w-52 ml-2s rounded-md leading-8"
          :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
          filter
          @change="campaign(eventSelect)"
        />
      </div>
    </Header>
    <Condition
      v-if="dataType == 'facebook'"
      @selectCharts="selectCharts"
      @search="handleSearchCondition"
      v-bind:dbCampaignId="dbCampaignId"
      v-bind:viewDatalist="ConditionItem"
      v-bind:logDatalist="logData"
      v-bind:campaignIdData="eventSelect"
      v-bind:defaultDateIntervalData="defaultDateInterval"
      v-bind:defaultMinDateData="defaultMinDate"
      v-bind:defaultMaxDateData="defaultMaxDate"
      v-bind:defaultSettiingDateListData="defaultSettiingDateList"
      v-bind:lang="showLang[selectLang]"
      v-bind:calendarMainShow="toCalendarMainShow"
      v-model:dateIntervalData="dateInterval"
    />
    <TikTokCondition
      v-if="dataType == 'tiktok'"
      @selectCharts="selectCharts"
      @search="handleSearchCondition"
      v-bind:dbCampaignId="dbCampaignId"
      v-bind:viewDatalist="ConditionItem"
      v-bind:logDatalist="logData"
      v-bind:campaignIdData="eventSelect"
      v-bind:defaultDateIntervalData="defaultDateInterval"
      v-bind:defaultMinDateData="defaultMinDate"
      v-bind:defaultMaxDateData="defaultMaxDate"
      v-bind:defaultSettiingDateListData="defaultSettiingDateList"
      v-bind:lang="showLang[selectLang]"
      v-bind:calendarMainShow="toCalendarMainShow"
      v-model:dateIntervalData="dateInterval"
    />
    <main class="d2-report-main">
      <div class="d2-report-icon-nav">
        <template v-if="dataType == 'facebook'">
          <div
            class="d2-report-icon-btn"
            :class="isChartSectionActive ? 'd2-report-icon-btn--active' : ''"
            v-tooltip="`${showLang[selectLang]['views']['Report']['block_text_a']}`"
            @click="scrollToChartSection"
          >
            <i class="pi pi-sliders-v"></i>
          </div>
          <div
            class="d2-report-icon-btn"
            :class="isMaterialChartSectionActive ? 'd2-report-icon-btn--active' : ''"
            v-tooltip="`${showLang[selectLang]['views']['Report']['block_text_b']}`"
            @click="scrollToMaterialChartSection"
          >
            <i class="pi pi-sliders-h"></i>
          </div>
          <div
            class="d2-report-icon-btn"
            :class="isAgeGenderMaterialChartSectionActive ? 'd2-report-icon-btn--active' : ''"
            v-tooltip="`${showLang[selectLang]['views']['Report']['block_text_c']}`"
            @click="scrollToAgeGenderMaterialChartSection"
          >
            <i class="pi pi-sliders-h"></i>
          </div>
          <div
            class="d2-report-icon-btn"
            :class="isKeywordSectionActive ? 'd2-report-icon-btn--active' : ''"
            v-tooltip="`${showLang[selectLang]['views']['Report']['block_text_d']}`"
            @click="scrollToKeywordSection"
          >
            <i class="pi pi-plus-circle"></i>
          </div>
        </template>
        <template v-if="dataType == 'tiktok'">
          <div
            class="d2-report-icon-btn"
            :class="isTiktokChartSectionActive ? 'd2-report-icon-btn--active' : ''"
            v-tooltip="`${showTiktokLang[selectLang]['views']['Report']['block_text_a']}`"
            @click="scrollToTiktokChartSection"
          >
            <i class="pi pi-sliders-v"></i>
          </div>
          <div
            class="d2-report-icon-btn"
            :class="isTiktokMaterialChartSectionActive ? 'd2-report-icon-btn--active' : ''"
            v-tooltip="`${showTiktokLang[selectLang]['views']['Report']['block_text_b']}`"
            @click="scrollToTiktokMaterialChartSection"
          >
            <i class="pi pi-sliders-h"></i>
          </div>
          <div
            class="d2-report-icon-btn"
            :class="isTiktokAgeGenderMaterialChartSectionActive ? 'd2-report-icon-btn--active' : ''"
            v-tooltip="`${showTiktokLang[selectLang]['views']['Report']['block_text_c']}`"
            @click="scrollToTiktokAgeGenderMaterialChartSection"
          >
            <i class="pi pi-sliders-h"></i>
          </div>
          <div
            class="d2-report-icon-btn"
            :class="isTiktokKeywordSectionActive ? 'd2-report-icon-btn--active' : ''"
            v-tooltip="`${showTiktokLang[selectLang]['views']['Report']['block_text_d']}`"
            @click="scrollToTiktokKeywordSection"
          >
            <i class="pi pi-plus-circle"></i>
          </div>
        </template>
      </div>

      <form id="plan_form" target="plan_form_open" action="https://www.google.com.tw"></form>

      <div v-show="dataType == 'facebook'" class="d2-report-content-area" ref="scrollBody">
        <div class="d2-report-tab-container" ref="chartSection">
          <loading :active="!this.showChartPanel"
                  :can-cancel="true"
                  :on-cancel="onCancel"
                  :is-full-page="false"
                  :color="'#fff'"
                  :background-color="'#000'"
                  :opacity="'0.8'"
                  :loader=" dots">
          </loading>
          <div class="d2-report-tab-row">
            <button
              v-for="(item, index) in displayChartPanel"
              :key="'fb-tab-'+index"
              class="d2-report-tab-btn"
              :class="{ active: activeChartTab === index }"
              @click="activeChartTab = index"
            >{{ item }}</button>
          </div>
          <template v-for="(item, index) in lineStylesData.datasets" :key="'fb-chart-'+index">
            <ChartPanel v-if="displayChartPanel.includes(displayChartPanel[index]) && activeChartTab === index" :title="displayChartPanel[index]" :chartsData="lineStylesData.datasets[index]" :tableData="tableData[index]" v-bind:lang="showLang[selectLang]" />
          </template>
        </div>
        <div class="flex flex-row flex-wrap items-start mb-3" ref="materialChartSection" style="width:98.5%; position:relative;">
          <loading :active="!this.showMaterialChartPanel"
                  :can-cancel="true"
                  :on-cancel="onCancel"
                  :is-full-page="false"
                  :color="'#fff'"
                  :background-color="'#000'"
                  :opacity="'0.8'"
                  :loader=" dots">
          </loading>
          <MaterialChartPanel v-if="displayChartPanel.includes(displayChartPanel[0])" :title="showLang[selectLang]['views']['Report']['block_text_b']" :allHieght="dbHeight" :chartPrview="materialChartPrview" :chartsData="materialChartData" :tableData="materialChartInfo" :lang="showLang[selectLang]"/>
        </div>
        <div class="flex flex-row flex-wrap items-start" ref="ageGenderMaterialChartSection" style="width:98.5%; position:relative;">
          <loading :active="!this.showAgeGenderMaterialChartPanel"
                  :can-cancel="true"
                  :on-cancel="onCancel"
                  :is-full-page="false"
                  :color="'#fff'"
                  :background-color="'#000'"
                  :opacity="'0.8'"
                  :loader=" dots">
          </loading>
          <AgeGenderMaterialChartPanel v-if="displayChartPanel.includes(displayChartPanel[1])" :title="showLang[selectLang]['views']['Report']['block_text_c']" :allHieght="dbAgeGenderHeight" :chartPrview="ageGenderMaterialChartPrview" :chartsData="ageGenderMaterialChartData" :tableData="ageGenderMaterialChartInfo" :lang="showLang[selectLang]"/>
        </div>
        <KeyWord v-bind:showKeyWord="showKeyWord" v-bind:viewDatalist="keywordList" v-bind:adaccountIdSelect="accountSelect" v-bind:campaignIdSelect="eventSelect" v-bind:lang="showLang[selectLang]"/>
      </div>

      <div v-show="dataType == 'tiktok'" class="d2-report-content-area" ref="tiktokScrollBody">
        <div class="d2-report-tab-container" ref="tiktokChartSection">
          <loading :active="!this.showChartPanel"
                  :can-cancel="true"
                  :on-cancel="onCancel"
                  :is-full-page="false"
                  :color="'#fff'"
                  :background-color="'#000'"
                  :opacity="'0.8'"
                  :loader=" dots">
          </loading>
          <div class="d2-report-tab-row">
            <button
              v-for="(item, index) in displayChartPanel"
              :key="'tt-tab-'+index"
              class="d2-report-tab-btn"
              :class="{ active: activeTiktokChartTab === index }"
              @click="activeTiktokChartTab = index"
            >{{ item }}</button>
          </div>
          <template v-for="(item, index) in lineStylesData.datasets" :key="'tt-chart-'+index">
            <TikTokChartPanel v-if="displayChartPanel.includes(displayChartPanel[index]) && activeTiktokChartTab === index" :title="displayChartPanel[index]" :chartsData="lineStylesData.datasets[index]" :tableData="tableData[index]" v-bind:lang="showLang[selectLang]" />
          </template>
        </div>
        <div class="flex flex-row flex-wrap items-start mb-3" ref="tiktokMaterialChartSection" style="width:98.5%; position:relative;">
          <loading :active="!this.showMaterialChartPanel"
                  :can-cancel="true"
                  :on-cancel="onCancel"
                  :is-full-page="false"
                  :color="'#fff'"
                  :background-color="'#000'"
                  :opacity="'0.8'"
                  :loader=" dots">
          </loading>
          <TikTokMaterialChartPanel :title="showLang[selectLang]['views']['Report']['block_text_b']" :allHieght="dbHeight" :chartPrview="materialChartPrview" :chartsData="materialChartData" :tableData="materialChartInfo" :lang="showLang[selectLang]"/>
        </div>
        <div class="flex flex-row flex-wrap items-start" ref="tiktokAgeGenderMaterialChartSection" style="width:98.5%; position:relative;">
          <loading :active="!this.showAgeGenderMaterialChartPanel"
                  :can-cancel="true"
                  :on-cancel="onCancel"
                  :is-full-page="false"
                  :color="'#fff'"
                  :background-color="'#000'"
                  :opacity="'0.8'"
                  :loader=" dots">
          </loading>
          <TikTokAgeGenderMaterialChartPanel :title="showLang[selectLang]['views']['Report']['block_text_c']" :allHieght="dbAgeGenderHeight" :chartPrview="ageGenderMaterialChartPrview" :chartsData="ageGenderMaterialChartData" :tableData="ageGenderMaterialChartInfo" :lang="showLang[selectLang]"/>
        </div>
        <TikTokKeyWord v-bind:showKeyWord="showKeyWord" v-bind:viewDatalist="keywordList" v-bind:adaccountIdSelect="accountSelect" v-bind:campaignIdSelect="eventSelect" v-bind:lang="showLang[selectLang]"/>
      </div>
    </main>
  </div>
</template>

<script>

import Dropdown from 'primevue/dropdown'
import Header from '@/components/Header.vue'
import Condition from '@/components/Report/Condition.vue'
import ChartPanel from '@/components/Report/Charts/ChartPanel.vue'
import MaterialChartPanel from '@/components/Report/Charts/MaterialChartPanel.vue'
import AgeGenderMaterialChartPanel from '@/components/Report/Charts/AgeGenderMaterialChartPanel.vue'
import KeyWord from '@/components/Report/KeyWord.vue'
import TikTokCondition from '@/components/TikTokReport/Condition.vue'
import TikTokChartPanel from '@/components/TikTokReport/Charts/ChartPanel.vue'
import TikTokMaterialChartPanel from '@/components/TikTokReport/Charts/MaterialChartPanel.vue'
import TikTokAgeGenderMaterialChartPanel from '@/components/TikTokReport/Charts/AgeGenderMaterialChartPanel.vue'
import TikTokKeyWord from '@/components/TikTokReport/KeyWord.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import { ref, onMounted } from 'vue'
import axios from 'axios'
import Qs from 'qs'
import lang from '@/language/lang.json'
import tiktokLang from '@/language/tiktok_lang.json'

export default {
  name: 'Report',
  components: {
    Header,
    Condition,
    ChartPanel,
    MaterialChartPanel,
    AgeGenderMaterialChartPanel,
    KeyWord,
    TikTokCondition,
    TikTokChartPanel,
    TikTokMaterialChartPanel,
    TikTokAgeGenderMaterialChartPanel,
    TikTokKeyWord,
    Dropdown,
    Loading,
  },
  setup() {
    const scrollBody = ref()
    const chartSection = ref()
    const materialChartSection = ref()
    const ageGenderMaterialChartSection = ref()
    const tiktokScrollBody = ref()
    const tiktokChartSection = ref()
    const tiktokMaterialChartSection = ref()
    const tiktokAgeGenderMaterialChartSection = ref()
    const isChartSectionActive = ref(true)
    const isMaterialChartSectionActive = ref(false)
    const isAgeGenderMaterialChartSectionActive = ref(false)
    const isKeywordSectionActive = ref(false)
    const isTiktokChartSectionActive = ref(true)
    const isTiktokMaterialChartSectionActive = ref(false)
    const isTiktokAgeGenderMaterialChartSectionActive = ref(false)
    const isTiktokKeywordSectionActive = ref(false)

    /**
     * [scrollToChartSection function]
     * @description: Scroll to chart section
     */
    const scrollToChartSection = () => {
      isKeywordSectionActive.value = false
      isMaterialChartSectionActive.value = false
      isAgeGenderMaterialChartSectionActive.value = false
      isChartSectionActive.value = true
      scrollBody.value.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }

    /**
     * [scrollToChartSection function]
     * @description: Scroll to chart section
     */
    const scrollToMaterialChartSection = () => {
      isKeywordSectionActive.value = false
      isMaterialChartSectionActive.value = true
      isAgeGenderMaterialChartSectionActive.value = false
      isChartSectionActive.value = false
      scrollBody.value.scrollTo({
        top: chartSection.value.offsetTop + chartSection.value.offsetHeight - 100,
        behavior: 'smooth'
      })
    }

    /**
     * [scrollToChartSection function]
     * @description: Scroll to chart section
     */
    const scrollToAgeGenderMaterialChartSection = () => {
      isKeywordSectionActive.value = false
      isMaterialChartSectionActive.value = false
      isAgeGenderMaterialChartSectionActive.value = true
      isChartSectionActive.value = false

      // console.log('chartSection.value.offsetTop');
      // console.log(chartSection.value.offsetTop);
      // console.log('chartSection.value.offsetHeight');
      // console.log(chartSection.value.offsetHeight);
      // console.log('materialChartSection.value.offsetTop');
      // console.log(materialChartSection.value.offsetTop);
      // console.log('materialChartSection.value.offsetHeight');
      // console.log(materialChartSection.value.offsetHeight);

      scrollBody.value.scrollTo({
        top: materialChartSection.value.offsetTop + materialChartSection.value.offsetHeight - 100,
        behavior: 'smooth'
      })
    }

    /**
     * [scrollToKeywordSection function]
     * @description: Scroll to keyword section
     */
    const scrollToKeywordSection = () => {
      isKeywordSectionActive.value = true
      isMaterialChartSectionActive.value = false
      isAgeGenderMaterialChartSectionActive.value = false
      isChartSectionActive.value = false
      scrollBody.value.scrollTo({
        top: chartSection.value.offsetTop + chartSection.value.offsetHeight + materialChartSection.value.offsetTop + materialChartSection.value.offsetHeight + ageGenderMaterialChartSection.value.offsetTop + ageGenderMaterialChartSection.value.offsetHeight,
        behavior: 'smooth'
      })
    }

    /**
     * [scrollToChartSection function]
     * @description: Scroll to chart section
     */
    const scrollToTiktokChartSection = () => {
      isTiktokKeywordSectionActive.value = false
      isTiktokMaterialChartSectionActive.value = false
      isTiktokAgeGenderMaterialChartSectionActive.value = false
      isTiktokChartSectionActive.value = true
      tiktokScrollBody.value.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }

    /**
     * [scrollToChartSection function]
     * @description: Scroll to chart section
     */
    const scrollToTiktokMaterialChartSection = () => {
      isTiktokKeywordSectionActive.value = false
      isTiktokMaterialChartSectionActive.value = true
      isTiktokAgeGenderMaterialChartSectionActive.value = false
      isTiktokChartSectionActive.value = false

      // console.log('chartSection.value.offsetTop');
      // console.log(chartSection.value.offsetTop);
      // console.log('chartSection.value.offsetHeight');
      // console.log(chartSection.value.offsetHeight);

      tiktokScrollBody.value.scrollTo({
        top: tiktokChartSection.value.offsetTop + tiktokChartSection.value.offsetHeight - 100,
        behavior: 'smooth'
      })
    }

    /**
     * [scrollToChartSection function]
     * @description: Scroll to chart section
     */
    const scrollToTiktokAgeGenderMaterialChartSection = () => {
      isKeywordSectionActive.value = false
      isTiktokMaterialChartSectionActive.value = false
      isTiktokAgeGenderMaterialChartSectionActive.value = true
      isChartSectionActive.value = false

      // console.log('chartSection.value.offsetTop');
      // console.log(chartSection.value.offsetTop);
      // console.log('chartSection.value.offsetHeight');
      // console.log(chartSection.value.offsetHeight);
      // console.log('materialChartSection.value.offsetTop');
      // console.log(materialChartSection.value.offsetTop);
      // console.log('materialChartSection.value.offsetHeight');
      // console.log(materialChartSection.value.offsetHeight);

      tiktokScrollBody.value.scrollTo({
        top: tiktokMaterialChartSection.value.offsetTop + tiktokMaterialChartSection.value.offsetHeight - 100,
        behavior: 'smooth'
      })
    }

    /**
     * [scrollToKeywordSection function]
     * @description: Scroll to keyword section
     */
    const scrollToTiktokKeywordSection = () => {
      isTiktokKeywordSectionActive.value = true
      isTiktokMaterialChartSectionActive.value = false
      isTiktokAgeGenderMaterialChartSectionActive.value = false
      isTiktokChartSectionActive.value = false
      tiktokScrollBody.value.scrollTo({
        top: tiktokChartSection.value.offsetTop + tiktokChartSection.value.offsetHeight + tiktokMaterialChartSection.value.offsetTop + tiktokMaterialChartSection.value.offsetHeight + tiktokAgeGenderMaterialChartSection.value.offsetTop - 100,
        behavior: 'smooth'
      })
    }

    onMounted(() => {
      scrollBody.value.addEventListener('scroll',() => {
        let chartSectionTopValue = chartSection.value.getBoundingClientRect().top;
        let chartSectionBottomValue = chartSection.value.getBoundingClientRect().bottom;
        let materialChartSectionTopValue = materialChartSection.value.getBoundingClientRect().top
        let materialChartSectionBottomValue = materialChartSection.value.getBoundingClientRect().bottom
        let ageGenderMaterialChartSectionTopValue = ageGenderMaterialChartSection.value.getBoundingClientRect().top
        let ageGenderMaterialChartSectionBottomValue = ageGenderMaterialChartSection.value.getBoundingClientRect().bottom

        let scrollBodyValue = scrollBody.value.offsetHeight
        let scrollTopValue = scrollBody.value.scrollTop

        let area01Height = parseInt(chartSectionBottomValue) - parseInt(chartSectionTopValue) + parseInt(78);

        let area02Height = parseInt(materialChartSectionBottomValue) - parseInt(materialChartSectionTopValue);

        let area03Height = parseInt(ageGenderMaterialChartSectionBottomValue) - parseInt(ageGenderMaterialChartSectionTopValue) + parseInt(24);

        if(chartSectionBottomValue > scrollTopValue){
          isChartSectionActive.value = true
          isMaterialChartSectionActive.value = false
          isAgeGenderMaterialChartSectionActive.value = false
          isKeywordSectionActive.value = false
        }

        if(area01Height <= scrollTopValue){
          isChartSectionActive.value = false
          isMaterialChartSectionActive.value = true
          isAgeGenderMaterialChartSectionActive.value = false
          isKeywordSectionActive.value = false
        }

        if((parseInt(area01Height) + parseInt(area02Height)) <= scrollTopValue){
          isChartSectionActive.value = false
          isMaterialChartSectionActive.value = false
          isAgeGenderMaterialChartSectionActive.value = true
          isKeywordSectionActive.value = false
        }

        if((parseInt(area01Height) + parseInt(area02Height) + parseInt(area03Height)) < scrollTopValue){
          isChartSectionActive.value = false
          isMaterialChartSectionActive.value = false
          isAgeGenderMaterialChartSectionActive.value = false
          isKeywordSectionActive.value = true
        }
      })

      tiktokScrollBody.value.addEventListener('scroll',() => {
        let tiktokChartSectionTopValue = tiktokChartSection.value.getBoundingClientRect().top;
        let tiktokChartSectionBottomValue = tiktokChartSection.value.getBoundingClientRect().bottom;
        let tiktokMaterialChartSectionTopValue = tiktokMaterialChartSection.value.getBoundingClientRect().top
        let tiktokMaterialChartSectionBottomValue = tiktokMaterialChartSection.value.getBoundingClientRect().bottom
        let tiktokAgeGenderMaterialChartSectionTopValue = tiktokAgeGenderMaterialChartSection.value.getBoundingClientRect().top
        let tiktokAgeGenderMaterialChartSectionBottomValue = tiktokAgeGenderMaterialChartSection.value.getBoundingClientRect().bottom
        let scrollBodyValue = tiktokScrollBody.value.offsetHeight
        let scrollTopValue = tiktokScrollBody.value.scrollTop

        let tiktokArea01Height = parseInt(tiktokChartSectionBottomValue) - parseInt(tiktokChartSectionTopValue) + parseInt(78);
        let tiktokArea02Height = parseInt(tiktokMaterialChartSectionBottomValue) - parseInt(tiktokMaterialChartSectionTopValue);
        let tiktokArea03Height = parseInt(tiktokAgeGenderMaterialChartSectionBottomValue) - parseInt(tiktokAgeGenderMaterialChartSectionTopValue) + parseInt(24);

        if(parseInt(tiktokChartSectionBottomValue) > scrollTopValue){
          isTiktokChartSectionActive.value = true
          isTiktokMaterialChartSectionActive.value = false
          isTiktokAgeGenderMaterialChartSectionActive.value = false
          isTiktokKeywordSectionActive.value = false
        }

        if(parseInt(tiktokArea01Height) <= scrollTopValue){
          isTiktokChartSectionActive.value = false
          isTiktokMaterialChartSectionActive.value = true
          isTiktokAgeGenderMaterialChartSectionActive.value = false
          isTiktokKeywordSectionActive.value = false
        }

        if((parseInt(tiktokArea01Height) + parseInt(tiktokArea02Height)) <= scrollTopValue){
          isTiktokChartSectionActive.value = false
          isTiktokMaterialChartSectionActive.value = false
          isTiktokAgeGenderMaterialChartSectionActive.value = true
          isTiktokKeywordSectionActive.value = false
        }

        if((parseInt(tiktokArea01Height) + parseInt(tiktokArea02Height) + parseInt(tiktokArea03Height)) < scrollTopValue){
          isTiktokChartSectionActive.value = false
          isTiktokMaterialChartSectionActive.value = false
          isTiktokAgeGenderMaterialChartSectionActive.value = false
          isTiktokKeywordSectionActive.value = true
        }
      })
    })

    return {
      isChartSectionActive,
      isMaterialChartSectionActive,
      isAgeGenderMaterialChartSectionActive,
      isKeywordSectionActive,
      isTiktokChartSectionActive,
      isTiktokMaterialChartSectionActive,
      isTiktokAgeGenderMaterialChartSectionActive,
      isTiktokKeywordSectionActive,
      scrollBody,
      chartSection,
      materialChartSection,
      ageGenderMaterialChartSection,
      tiktokScrollBody,
      tiktokChartSection,
      tiktokMaterialChartSection,
      tiktokAgeGenderMaterialChartSection,
      scrollToChartSection,
      scrollToMaterialChartSection,
      scrollToAgeGenderMaterialChartSection,
      scrollToKeywordSection,
      scrollToTiktokChartSection,
      scrollToTiktokMaterialChartSection,
      scrollToTiktokAgeGenderMaterialChartSection,
      scrollToTiktokKeywordSection
    }
  },
  data() {
    return {
      selectLang: 'zh-TW',
      showLang: lang,
      showTiktokLang: tiktokLang,
      fromAccountSelect: 'facebook',
       // ========== 暫時隱藏 TikTok 選項 ==========
      // 原選項: [{"name":"Facebook","code":"facebook"},{"name":"Tiktok","code":"tiktok"}]
      fromAccountOptions: [{"name":"Facebook","code":"facebook"}],
      // ========== 暫時隱藏 TikTok 選項結束 ==========
      dataType: 'facebook',
      accountSelect: '未來實驗室',
      accountOptions: ['未來實驗室'],
      eventSelect: '',
      eventOptions: ['活動001', '活動002', '超級活動'],
      displayChartPanel: [],
      activeChartTab: 0,
      activeTiktokChartTab: 0,
      ConditionItem: [],
      tableData: [],
      lineStylesData: {
        datasets: []
      },
      keywordList: [],
      dateInterval: [],
      defaultDateInterval: [],
      defaultMinDate: null,
      defaultMaxDate: null,
      logData: [],
      showChartPanel: false,
      showKeyWord: false,
      dbHeight: 80,
      dbAgeGenderHeight: 80,
      materialChartData: {},
      ageGenderMaterialChartData: {},
      materialChartPrview: {},
      ageGenderMaterialChartPrview: {},
      materialChartInfo: {},
      ageGenderMaterialChartInfo: {},
      dbCampaignId: '',
      toCalendarMainShow: false,
      defaultSettiingDateList: [],
      chartOptions: {
        chart: {
          id: "vuechart-example",
          toolbar: {
            tools: {
              pan: false
            }
          }
        },
        colors: ["#FF1654", "#247BA0"],
        xaxis: {
          categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
        },
        annotations: {
          xaxis: [{
            x: 1992,
            x2: 1994,
            fillColor: '#FFB3C7',
            opacity: 0.4,
            label: {
              borderColor: '#FFB3C7',
              style: {
                fontSize: '10px',
                color: '#fff',
                background: '#FF1654',
              },
              offsetY: -10,
              text: '提示一',
            },
          },{
            x: 1995,
            x2: 1996,
            fillColor: '#247BA0',
            opacity: 0.4,
            label: {
              borderColor: '#247BA0',
              style: {
                fontSize: '10px',
                color: '#fff',
                background: '#247BA0',
              },
              offsetY: -10,
              text: '廣告素材呈現疲乏，建議更換新的創意內容',
            },
          }],
        },

      },
      series: [
        {
          name: "series-1",
          data: [30, 40, 35, 50, 49, 60, 70, 91],
        },
        {
          name: "series-2",
          data: [50, 44, 75, 78, 86, 94, 88, 62],
        },
      ],
    }
  },
  created() {
    // console.log('created');
    // window.open("https://www.google.com", '_blank');
    let hash = this.$route.params.id;
    let routeType = this.$route.params.type;
    let campaignAdaccountsUrl = 'https://www.autoturn.net/api/campaign_adaccounts.php';
    let reportChartUrl = 'https://www.autoturn.net/api/report/report_chart.php';
    let reportMaterialChartUrl = 'https://www.autoturn.net/api/report/report_material_chart.php';
    let reportAgeGenderMaterialChartUrl = 'https://www.autoturn.net/api/report/report_age_gender_material_chart.php';
    let reportKeywordUrl = 'https://www.autoturn.net/api/report/report_keyword.php';

    if(routeType != '' && routeType != null && typeof routeType != 'undefined'){
      if(routeType == 't'){
        this.fromAccountSelect = 'tiktok';
        this.dataType = 'tiktok';

        campaignAdaccountsUrl = 'https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_adaccounts.php';
        reportChartUrl = 'https://www.autoturn.net/api/tiktok/report/report_chart.php';
        reportMaterialChartUrl = 'https://www.autoturn.net/api/tiktok/report/report_material_chart.php';
        reportAgeGenderMaterialChartUrl = 'https://www.autoturn.net/api/tiktok/report/report_age_gender_material_chart.php';
        reportKeywordUrl = 'https://www.autoturn.net/api/tiktok/report/report_keyword.php';
      }
    }

    if(hash != '' && hash != null && typeof hash != 'undefined'){

      let member_hash = this.$route.params.id
      let adaccount_id = this.$route.params.adaccount_id

      if(adaccount_id != '' && adaccount_id != null && typeof adaccount_id != 'undefined'){
        adaccount_id = "/"+this.$route.params.adaccount_id
      }

      axios
        .post('https://www.autoturn.net/api/campaign_member_status.php', Qs.stringify({
          s_code: member_hash,
          route_type: this.$route.params.type,
          active: 'chart',
        }))
        .then((caResponse) => {

          if(caResponse.data.status == 'error'){
            if(caResponse.data.type == 2){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/report/"+routeType+"/"+member_hash+"/"+adaccount_id;
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/report/"+routeType+"/"+member_hash+"/"+adaccount_id;
                }
              })
            } else if(caResponse.data.type == 3){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/"+routeType+"/"+member_hash;
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/"+routeType+"/"+member_hash;
                }
              })
            } else {
              Swal.fire(
                        this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['error']['swal_title'],
                        caResponse.data.info,
                        caResponse.data.status
                      )
            }
          }

          if(caResponse.data.status == 'warning'){
            Swal.fire({
              icon: 'warning',
              title: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['warning']['swal_title'],
              text: caResponse.data.info,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['warning']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              if (result.isConfirmed) {
                axios
                  .post(campaignAdaccountsUrl, Qs.stringify({
                    s_code: this.$route.params.id,
                    adaccount_id: this.$route.params.adaccount_id,
                    type: 'report',
                  }))
                  .then((adResponse) => {
                    // console.log(adResponse.data);
                    if(adResponse.data.status == 'success'){

                      if(adResponse.data.return_data.length > 0){
                        this.accountOptions = adResponse.data.return_data
                        this.accountSelect = adResponse.data.selecded_data

                        axios
                          .post('https://www.autoturn.net/api/adaccount_campaign_list.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            adaccount_id: adResponse.data.selecded_data,
                            campaign_id: this.$route.params.campaign_id,
                            type: routeType,
                          }))
                          .then((listResponse) => {
                            // console.log(listResponse.data);
                            if(listResponse.data.status == 'success'){
                              this.eventOptions = listResponse.data.return_data
                              this.eventSelect = listResponse.data.selecded_data

                              // console.log('created eventSelect');
                              // console.log(this.eventSelect);

                              axios
                                .post(reportChartUrl, Qs.stringify({
                                  s_code: this.$route.params.id,
                                  campaign_id: listResponse.data.selecded_data
                                }))
                                .then((reResponse) => {
                                  // console.log(reResponse.data);
                                  if(reResponse.data.status == 'success'){
                                    this.ConditionItem = reResponse.data.condition_item
                                    this.displayChartPanel = reResponse.data.chart_panel
                                    this.tableData = reResponse.data.info_data
                                    this.lineStylesData.datasets = reResponse.data.return_data

                                    // console.log('this.lineStylesData.datasets');
                                    // console.log(this.lineStylesData.datasets);

                                    let select_date_start = reResponse.data.date_start;
                                    let select_date_end = reResponse.data.date_end;
                                    if(reResponse.data.select_date_start != '' && reResponse.data.select_date_start != null && typeof reResponse.data.select_date_start != 'undefined'){
                                      select_date_start = reResponse.data.select_date_start;
                                    }
                                    if(reResponse.data.select_date_end != '' && reResponse.data.select_date_end != null && typeof reResponse.data.select_date_end != 'undefined'){
                                      select_date_end = reResponse.data.select_date_end;
                                    }

                                    this.defaultDateInterval = [new Date(select_date_start), new Date(select_date_end)]

                                    this.defaultMinDate = new Date(reResponse.data.date_start)
                                    this.defaultMaxDate = new Date(reResponse.data.date_end)

                                    this.defaultSettiingDateList = reResponse.data.setting_date
                                  }

                                  this.showChartPanel = true;
                                });

                              axios
                                .post(reportMaterialChartUrl, Qs.stringify({
                                  s_code: this.$route.params.id,
                                  campaign_id: listResponse.data.selecded_data
                                }))
                                .then((mchResponse) => {
                                  // console.log(mchResponse.data);
                                  if(mchResponse.data.status == 'success'){
                                    this.dbHeight = mchResponse.data.height
                                    this.materialChartData = mchResponse.data.chart_data
                                    // this.materialChartData.labels = mchResponse.data.materialChartData_labels
                                    // this.materialChartData.datasets[0].data = mchResponse.data.datasets_data
                                    // this.materialChartData.datasets[0].backgroundColor = mchResponse.data.datasets_backgroundColor
                                    // this.materialChartData.datasets[0].borderColor = mchResponse.data.datasets_borderColor
                                    this.materialChartPrview = mchResponse.data.chart_prview
                                    this.materialChartInfo = mchResponse.data.chart_info
                                  }

                                  this.showMaterialChartPanel = true;
                                });

                              axios
                                .post(reportAgeGenderMaterialChartUrl, Qs.stringify({
                                  s_code: this.$route.params.id,
                                  campaign_id: listResponse.data.selecded_data
                                }))
                                .then((mchResponse) => {
                                  // console.log(mchResponse.data);
                                  if(mchResponse.data.status == 'success'){
                                    this.dbAgeGenderHeight = mchResponse.data.height
                                    this.ageGenderMaterialChartData = mchResponse.data.chart_data
                                    // this.materialChartData.labels = mchResponse.data.materialChartData_labels
                                    // this.materialChartData.datasets[0].data = mchResponse.data.datasets_data
                                    // this.materialChartData.datasets[0].backgroundColor = mchResponse.data.datasets_backgroundColor
                                    // this.materialChartData.datasets[0].borderColor = mchResponse.data.datasets_borderColor
                                    this.ageGenderMaterialChartPrview = mchResponse.data.chart_prview
                                    this.ageGenderMaterialChartInfo = mchResponse.data.chart_info
                                  }

                                  this.showAgeGenderMaterialChartPanel = true;
                                });

                              axios
                                .post(reportKeywordUrl, Qs.stringify({
                                  s_code: this.$route.params.id,
                                  campaign_id: listResponse.data.selecded_data
                                }))
                                .then((reResponse) => {
                                  // console.log(reResponse.data);

                                  this.keywordList = reResponse.data.return_data

                                  // console.log(this.keywordList);

                                  this.showKeyWord = true;
                                });

                              this.dbCampaignId = listResponse.data.selecded_data

                              // axios
                              //   .post('https://www.autoturn.net/api/report/report_log_list.php', Qs.stringify({
                              //     s_code: this.$route.params.id,
                              //     campaign_id: listResponse.data.selecded_data
                              //   }))
                              //   .then((reResponse) => {
                              //     // console.log(reResponse.data);

                              //     this.logData = reResponse.data.return_data

                              //     // console.log(this.keywordList);
                              //   });
                            } else {
                              this.eventOptions = [];
                              this.eventSelect = '';
                              this.showChartPanel = true;
                              this.showKeyWord = true;
                            }
                          });
                      } else {
                        this.showChartPanel = true;
                        this.showKeyWord = true;

                        Swal.fire({
                          icon: 'error',
                          title: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['warning']['data_empty_title'],
                          text: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['warning']['data_empty_text'],
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['warning']['data_empty_confirm_button']
                        }).then((result) => {
                          if (result.isConfirmed) {
                            window.location.href = "https://private.autoturn.net/"+routeType+"/"+hash;
                          } else if (result.isDenied) {
                            window.location.href = "https://private.autoturn.net/"+routeType+"/"+hash;
                          }
                        })
                      }
                    }

                    if(adResponse.data.status == 'login'){
                      Swal.fire({
                        icon: 'error',
                        title: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['error']['swal_title'],
                        text: adResponse.data.info,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['error']['confirm_button']
                        // denyButtonText: `Don't save`,
                      }).then((result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                          // Swal.fire('Saved!', '', 'success')
                          // this.allPageLoading = true
                          window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                          // this.allPageLoading = true
                          window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                        }
                      })
                    }
                  });
              }
            });
          }

          if(caResponse.data.status == 'success'){
            axios
              .post(campaignAdaccountsUrl, Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                type: 'report',
              }))
              .then((adResponse) => {
                // console.log(adResponse.data);
                if(adResponse.data.status == 'success'){

                  if(adResponse.data.return_data.length > 0){
                    this.accountOptions = adResponse.data.return_data
                    this.accountSelect = adResponse.data.selecded_data

                    axios
                      .post('https://www.autoturn.net/api/adaccount_campaign_list.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        adaccount_id: adResponse.data.selecded_data,
                        campaign_id: this.$route.params.campaign_id,
                        type: routeType,
                      }))
                      .then((listResponse) => {
                        // console.log(listResponse.data);
                        if(listResponse.data.status == 'success'){
                          this.eventOptions = listResponse.data.return_data
                          this.eventSelect = listResponse.data.selecded_data

                          // console.log('created eventSelect');
                          // console.log(this.eventSelect);

                          axios
                            .post(reportChartUrl, Qs.stringify({
                              s_code: this.$route.params.id,
                              campaign_id: listResponse.data.selecded_data
                            }))
                            .then((reResponse) => {
                              // console.log(reResponse.data);
                              if(reResponse.data.status == 'success'){
                                this.ConditionItem = reResponse.data.condition_item
                                this.displayChartPanel = reResponse.data.chart_panel
                                this.tableData = reResponse.data.info_data
                                this.lineStylesData.datasets = reResponse.data.return_data

                                // console.log('this.lineStylesData.datasets');
                                // console.log(this.lineStylesData.datasets);
                                let select_date_start = reResponse.data.date_start;
                                let select_date_end = reResponse.data.date_end;
                                if(reResponse.data.select_date_start != '' && reResponse.data.select_date_start != null && typeof reResponse.data.select_date_start != 'undefined'){
                                  select_date_start = reResponse.data.select_date_start;
                                }
                                if(reResponse.data.select_date_end != '' && reResponse.data.select_date_end != null && typeof reResponse.data.select_date_end != 'undefined'){
                                  select_date_end = reResponse.data.select_date_end;
                                }

                                this.defaultDateInterval = [new Date(select_date_start), new Date(select_date_end)]

                                this.defaultMinDate = new Date(reResponse.data.date_start)
                                this.defaultMaxDate = new Date(reResponse.data.date_end)

                                this.defaultSettiingDateList = reResponse.data.setting_date
                              }

                              this.showChartPanel = true;
                            });

                          axios
                            .post(reportMaterialChartUrl, Qs.stringify({
                              s_code: this.$route.params.id,
                              campaign_id: listResponse.data.selecded_data
                            }))
                            .then((mchResponse) => {
                              // console.log('report_material_chart');
                              // console.log(mchResponse.data);
                              if(mchResponse.data.status == 'success'){
                                this.dbHeight = mchResponse.data.height
                                this.materialChartData = mchResponse.data.chart_data
                                // this.materialChartData.labels = mchResponse.data.materialChartData_labels
                                // this.materialChartData.datasets[0].data = mchResponse.data.datasets_data
                                // this.materialChartData.datasets[0].backgroundColor = mchResponse.data.datasets_backgroundColor
                                // this.materialChartData.datasets[0].borderColor = mchResponse.data.datasets_borderColor
                                this.materialChartPrview = mchResponse.data.chart_prview
                                this.materialChartInfo = mchResponse.data.chart_info
                              }

                              this.showMaterialChartPanel = true;
                            });

                          axios
                              .post(reportAgeGenderMaterialChartUrl, Qs.stringify({
                                s_code: this.$route.params.id,
                                campaign_id: listResponse.data.selecded_data
                              }))
                              .then((mchResponse) => {
                                // console.log(mchResponse.data);
                                if(mchResponse.data.status == 'success'){
                                  this.dbAgeGenderHeight = mchResponse.data.height
                                  this.ageGenderMaterialChartData = mchResponse.data.chart_data
                                  // this.materialChartData.labels = mchResponse.data.materialChartData_labels
                                  // this.materialChartData.datasets[0].data = mchResponse.data.datasets_data
                                  // this.materialChartData.datasets[0].backgroundColor = mchResponse.data.datasets_backgroundColor
                                  // this.materialChartData.datasets[0].borderColor = mchResponse.data.datasets_borderColor
                                  this.ageGenderMaterialChartPrview = mchResponse.data.chart_prview
                                  this.ageGenderMaterialChartInfo = mchResponse.data.chart_info
                                }

                                this.showAgeGenderMaterialChartPanel = true;
                              });

                          axios
                            .post(reportKeywordUrl, Qs.stringify({
                              s_code: this.$route.params.id,
                              campaign_id: listResponse.data.selecded_data
                            }))
                            .then((reResponse) => {
                              // console.log(reResponse.data);

                              this.keywordList = reResponse.data.return_data

                              // console.log(this.keywordList);

                              this.showKeyWord = true;
                            });

                          this.dbCampaignId = listResponse.data.selecded_data

                          // axios
                          //   .post('https://www.autoturn.net/api/report/report_log_list.php', Qs.stringify({
                          //     s_code: this.$route.params.id,
                          //     campaign_id: listResponse.data.selecded_data
                          //   }))
                          //   .then((reResponse) => {
                          //     // console.log(reResponse.data);

                          //     this.logData = reResponse.data.return_data

                          //     // console.log(this.keywordList);
                          //   });
                        } else {
                          this.eventOptions = [];
                          this.eventSelect = '';
                          this.showChartPanel = true;
                          this.showKeyWord = true;
                        }
                      });
                  } else {
                    this.showChartPanel = true;
                    this.showKeyWord = true;

                    Swal.fire({
                      icon: 'error',
                      title: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['success']['data_empty_title'],
                      text: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['success']['data_empty_text'],
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['success']['data_empty_confirm_button']
                    }).then((result) => {
                      if (result.isConfirmed) {
                        window.location.href = "https://private.autoturn.net/"+routeType+"/"+hash;
                      } else if (result.isDenied) {
                        window.location.href = "https://private.autoturn.net/"+routeType+"/"+hash;
                      }
                    })
                  }
                }

                if(adResponse.data.status == 'login'){
                  Swal.fire({
                    icon: 'error',
                    title: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['login']['swal_title'],
                    text: adResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['login']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      // this.allPageLoading = true
                      window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      // this.allPageLoading = true
                      window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                    }
                  })
                }
              });
          }
        });
    } else {
      Swal.fire({
        icon: 'error',
        title: this.showLang[this.selectLang]['views']['Report']['created']['no_hash_swal_title'],
        text: this.showLang[this.selectLang]['views']['Report']['created']['no_hash_swal_text'],
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: this.showLang[this.selectLang]['views']['Report']['created']['no_hash_confirm_button']
        // denyButtonText: `Don't save`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          // Swal.fire('Saved!', '', 'success')
          // this.allPageLoading = true
          window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
        } else if (result.isDenied) {
          // Swal.fire('Changes are not saved', '', 'info')
          // this.allPageLoading = true
          window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
        }
      })
    }
  },
  watch:{
    dateInterval(v){
      // console.log('report dateInterval');
      // console.log(v);

      let return_date = [];

      var date = new Date();
      const formatDate = (date)=>{
        let formatted_date = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
        return formatted_date;
      }

      for (let i = 0; i < v.length; i++) {
        if(v[i] != '' && v[i] != null){
          return_date.push(formatDate(v[i]));
        }
      }

      const date1 = new Date(return_date[0]);
      const date2 = new Date(return_date[1]);
      const timestamp1 = date1.getTime();
      const timestamp2 = date2.getTime();
      const timeDifference = Math.abs(timestamp1 - timestamp2);
      const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

      if(daysDifference <= 30){
        //console.log('report dateInterval return_date');
        //console.log(return_date);

        let report_chart_url = 'https://www.autoturn.net/api/report/report_chart.php';
        if(this.dataType == 'tiktok'){
          report_chart_url = 'https://www.autoturn.net/api/tiktok/report/report_chart.php';
        }

        if(v != ''){
          axios
            .post(report_chart_url, Qs.stringify({
              s_code: this.$route.params.id,
              campaign_id: this.eventSelect,
              date: return_date
            }))
            .then((reResponse) => {
              // console.log(reResponse.data);
              if(reResponse.data.status == 'success'){
                this.ConditionItem = reResponse.data.condition_item
                this.displayChartPanel = reResponse.data.chart_panel
                this.tableData = reResponse.data.info_data
                this.lineStylesData.datasets = reResponse.data.return_data

                let select_date_start = reResponse.data.date_start;
                let select_date_end = reResponse.data.date_end;
                if(reResponse.data.select_date_start != '' && reResponse.data.select_date_start != null && typeof reResponse.data.select_date_start != 'undefined'){
                  select_date_start = reResponse.data.select_date_start;
                }
                if(reResponse.data.select_date_end != '' && reResponse.data.select_date_end != null && typeof reResponse.data.select_date_end != 'undefined'){
                  select_date_end = reResponse.data.select_date_end;
                }

                this.defaultDateInterval = [new Date(select_date_start), new Date(select_date_end)]

                // this.defaultDateInterval = [new Date(reResponse.data.date_start), new Date(reResponse.data.date_end)]

                this.defaultMinDate = new Date(reResponse.data.date_start)
                this.defaultMaxDate = new Date(reResponse.data.date_end)
              }
            });
        }
      } else {
        Swal.fire(
          this.showLang[this.selectLang]['views']['Report']['watch']['dateInterval']['dateInterval_long_time_swal_title'],
          this.showLang[this.selectLang]['views']['Report']['watch']['dateInterval']['dateInterval_long_time_swal_text'],
          'warning'
        )
      }
    },
    fromAccountSelect(v){
      //console.log('fromAccountSelect');
      //console.log(v);

      this.dataType = v

      let routeType = 'f';
      let campaignAdaccountsUrl = 'https://www.autoturn.net/api/campaign_adaccounts.php';
      let reportChartUrl = 'https://www.autoturn.net/api/report/report_chart.php';
      let reportMaterialChartUrl = 'https://www.autoturn.net/api/report/report_material_chart.php';
      let reportAgeGenderMaterialChartUrl = 'https://www.autoturn.net/api/report/report_age_gender_material_chart.php';
      let reportKeywordUrl = 'https://www.autoturn.net/api/report/report_keyword.php';

      if(v == 'tiktok'){
        routeType = 't';
        campaignAdaccountsUrl = 'https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_adaccounts.php';
        reportChartUrl = 'https://www.autoturn.net/api/tiktok/report/report_chart.php';
        reportMaterialChartUrl = 'https://www.autoturn.net/api/tiktok/report/report_material_chart.php';
        reportAgeGenderMaterialChartUrl = 'https://www.autoturn.net/api/tiktok/report/report_age_gender_material_chart.php';
        reportKeywordUrl = 'https://www.autoturn.net/api/tiktok/report/report_keyword.php';
      }

      this.$router.push({ params: { type: routeType }});

      axios
        .post(campaignAdaccountsUrl, Qs.stringify({
          s_code: this.$route.params.id,
          adaccount_id: this.$route.params.adaccount_id,
          type: 'report',
        }))
        .then((adResponse) => {
          // console.log(adResponse.data);
          if(adResponse.data.status == 'success'){

            if(adResponse.data.return_data.length > 0){
              this.accountOptions = adResponse.data.return_data
              this.accountSelect = adResponse.data.selecded_data

              axios
                .post('https://www.autoturn.net/api/adaccount_campaign_list.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adaccount_id: adResponse.data.selecded_data,
                  campaign_id: this.$route.params.campaign_id,
                  type: routeType,
                }))
                .then((listResponse) => {
                  // console.log(listResponse.data);
                  if(listResponse.data.status == 'success'){
                    this.eventOptions = listResponse.data.return_data
                    this.eventSelect = listResponse.data.selecded_data

                    // console.log('created eventSelect');
                    // console.log(this.eventSelect);

                    axios
                      .post(reportChartUrl, Qs.stringify({
                        s_code: this.$route.params.id,
                        campaign_id: listResponse.data.selecded_data
                      }))
                      .then((reResponse) => {
                        // console.log(reResponse.data);
                        if(reResponse.data.status == 'success'){
                          this.ConditionItem = reResponse.data.condition_item
                          this.displayChartPanel = reResponse.data.chart_panel
                          this.tableData = reResponse.data.info_data
                          this.lineStylesData.datasets = reResponse.data.return_data

                          // console.log('this.lineStylesData.datasets');
                          // console.log(this.lineStylesData.datasets);
                          let select_date_start = reResponse.data.date_start;
                          let select_date_end = reResponse.data.date_end;
                          if(reResponse.data.select_date_start != '' && reResponse.data.select_date_start != null && typeof reResponse.data.select_date_start != 'undefined'){
                            select_date_start = reResponse.data.select_date_start;
                          }
                          if(reResponse.data.select_date_end != '' && reResponse.data.select_date_end != null && typeof reResponse.data.select_date_end != 'undefined'){
                            select_date_end = reResponse.data.select_date_end;
                          }

                          this.defaultDateInterval = [new Date(select_date_start), new Date(select_date_end)]

                          this.defaultMinDate = new Date(reResponse.data.date_start)
                          this.defaultMaxDate = new Date(reResponse.data.date_end)

                          this.defaultSettiingDateList = reResponse.data.setting_date
                        }

                        this.showChartPanel = true;
                      });

                    axios
                      .post(reportMaterialChartUrl, Qs.stringify({
                        s_code: this.$route.params.id,
                        campaign_id: listResponse.data.selecded_data
                      }))
                      .then((mchResponse) => {
                        // console.log('report_material_chart');
                        // console.log(mchResponse.data);
                        if(mchResponse.data.status == 'success'){
                          this.dbHeight = mchResponse.data.height
                          this.materialChartData = mchResponse.data.chart_data
                          // this.materialChartData.labels = mchResponse.data.materialChartData_labels
                          // this.materialChartData.datasets[0].data = mchResponse.data.datasets_data
                          // this.materialChartData.datasets[0].backgroundColor = mchResponse.data.datasets_backgroundColor
                          // this.materialChartData.datasets[0].borderColor = mchResponse.data.datasets_borderColor
                          this.materialChartPrview = mchResponse.data.chart_prview
                          this.materialChartInfo = mchResponse.data.chart_info
                        }

                        this.showMaterialChartPanel = true;
                      });

                    axios
                        .post(reportAgeGenderMaterialChartUrl, Qs.stringify({
                          s_code: this.$route.params.id,
                          campaign_id: listResponse.data.selecded_data
                        }))
                        .then((mchResponse) => {
                          // console.log(mchResponse.data);
                          if(mchResponse.data.status == 'success'){
                            this.dbAgeGenderHeight = mchResponse.data.height
                            this.ageGenderMaterialChartData = mchResponse.data.chart_data
                            // this.materialChartData.labels = mchResponse.data.materialChartData_labels
                            // this.materialChartData.datasets[0].data = mchResponse.data.datasets_data
                            // this.materialChartData.datasets[0].backgroundColor = mchResponse.data.datasets_backgroundColor
                            // this.materialChartData.datasets[0].borderColor = mchResponse.data.datasets_borderColor
                            this.ageGenderMaterialChartPrview = mchResponse.data.chart_prview
                            this.ageGenderMaterialChartInfo = mchResponse.data.chart_info
                          }

                          this.showAgeGenderMaterialChartPanel = true;
                        });

                    axios
                      .post(reportKeywordUrl, Qs.stringify({
                        s_code: this.$route.params.id,
                        campaign_id: listResponse.data.selecded_data
                      }))
                      .then((reResponse) => {
                        // console.log(reResponse.data);

                        this.keywordList = reResponse.data.return_data

                        //console.log('this.keywordList');
                        //console.log(this.keywordList);

                        this.showKeyWord = true;
                      });

                    this.dbCampaignId = listResponse.data.selecded_data

                    // axios
                    //   .post('https://www.autoturn.net/api/report/report_log_list.php', Qs.stringify({
                    //     s_code: this.$route.params.id,
                    //     campaign_id: listResponse.data.selecded_data
                    //   }))
                    //   .then((reResponse) => {
                    //     // console.log(reResponse.data);

                    //     this.logData = reResponse.data.return_data

                    //     // console.log(this.keywordList);
                    //   });
                  } else {
                    this.eventOptions = [];
                    this.eventSelect = '';
                    this.showChartPanel = true;
                    this.showKeyWord = true;
                  }
                });
            } else {
              this.showChartPanel = true;
              this.showKeyWord = true;

              Swal.fire({
                icon: 'error',
                title: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['success']['data_empty_title'],
                text: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['success']['data_empty_text'],
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['Report']['created']['axios']['campaign_member_status']['success']['data_empty_confirm_button']
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.href = "https://private.autoturn.net/"+routeType+"/"+hash;
                } else if (result.isDenied) {
                  window.location.href = "https://private.autoturn.net/"+routeType+"/"+hash;
                }
              })
            }
          }
        });

      // axios
      //   .post(reportChartUrl, Qs.stringify({
      //     s_code: this.$route.params.id,
      //     campaign_id: this.eventSelect
      //   }))
      //   .then((reResponse) => {
      //     // console.log(reResponse.data);
      //     if(reResponse.data.status == 'success'){
      //       this.ConditionItem = reResponse.data.condition_item
      //       this.displayChartPanel = reResponse.data.chart_panel
      //       this.tableData = reResponse.data.info_data
      //       this.lineStylesData.datasets = reResponse.data.return_data

      //       // console.log('this.lineStylesData.datasets');
      //       // console.log(this.lineStylesData.datasets);

      //       this.defaultDateInterval = [new Date(reResponse.data.date_start), new Date(reResponse.data.date_end)]

      //       this.defaultMinDate = new Date(reResponse.data.date_start)
      //       this.defaultMaxDate = new Date(reResponse.data.date_end)

      //       this.defaultSettiingDateList = reResponse.data.setting_date
      //     }

      //     this.showChartPanel = true;
      //   });

      // axios
      //   .post(reportMaterialChartUrl, Qs.stringify({
      //     s_code: this.$route.params.id,
      //     campaign_id: this.eventSelect
      //   }))
      //   .then((mchResponse) => {
      //     // console.log('report_material_chart');
      //     // console.log(mchResponse.data);
      //     if(mchResponse.data.status == 'success'){
      //       this.dbHeight = mchResponse.data.height
      //       this.materialChartData = mchResponse.data.chart_data
      //       // this.materialChartData.labels = mchResponse.data.materialChartData_labels
      //       // this.materialChartData.datasets[0].data = mchResponse.data.datasets_data
      //       // this.materialChartData.datasets[0].backgroundColor = mchResponse.data.datasets_backgroundColor
      //       // this.materialChartData.datasets[0].borderColor = mchResponse.data.datasets_borderColor
      //       this.materialChartPrview = mchResponse.data.chart_prview
      //       this.materialChartInfo = mchResponse.data.chart_info
      //     }

      //     this.showMaterialChartPanel = true;
      //   });

      // axios
      //   .post(reportAgeGenderMaterialChartUrl, Qs.stringify({
      //     s_code: this.$route.params.id,
      //     campaign_id: this.eventSelect
      //   }))
      //   .then((mchResponse) => {
      //     // console.log(mchResponse.data);
      //     if(mchResponse.data.status == 'success'){
      //       this.dbAgeGenderHeight = mchResponse.data.height
      //       this.ageGenderMaterialChartData = mchResponse.data.chart_data
      //       // this.materialChartData.labels = mchResponse.data.materialChartData_labels
      //       // this.materialChartData.datasets[0].data = mchResponse.data.datasets_data
      //       // this.materialChartData.datasets[0].backgroundColor = mchResponse.data.datasets_backgroundColor
      //       // this.materialChartData.datasets[0].borderColor = mchResponse.data.datasets_borderColor
      //       this.ageGenderMaterialChartPrview = mchResponse.data.chart_prview
      //       this.ageGenderMaterialChartInfo = mchResponse.data.chart_info
      //     }

      //     this.showAgeGenderMaterialChartPanel = true;
      //   });

      // axios
      //   .post(reportKeywordUrl, Qs.stringify({
      //     s_code: this.$route.params.id,
      //     campaign_id: this.eventSelect
      //   }))
      //   .then((reResponse) => {
      //     // console.log(reResponse.data);

      //     this.keywordList = reResponse.data.return_data

      //     console.log('this.keywordList');
      //     console.log(this.keywordList);

      //     this.showKeyWord = true;
      //   });
    }
  },
  methods: {
    useLang(v){
      if(v == '' || v == null || typeof v == 'undefined'){
        v = 'zh-TW';
      }

      this.selectLang = v
      this.$emit('childLang', v);

      document.title = this.showLang[this.selectLang]['views']['Report']['mounted']['page_name']+' - AutoTurn';
    },
    handleSearchCondition(data) {
      // console.log(data);
    },
    selectCharts(select) {
      this.displayChartPanel = [];
      select.map((e) => {
        this.displayChartPanel.push(e.val);
      });
    },
    adaccount(value){
      this.showChartPanel = false;
      this.showMaterialChartPanel = false;
      this.showAgeGenderMaterialChartPanel = false;
      this.showKeyWord = false;

      let reportChartUrl = 'https://www.autoturn.net/api/report/report_chart.php';
      let reportMaterialChartUrl = 'https://www.autoturn.net/api/report/report_material_chart.php';
      let reportAgeGenderMaterialChartUrl = 'https://www.autoturn.net/api/report/report_age_gender_material_chart.php';
      let reportKeywordUrl = 'https://www.autoturn.net/api/report/report_keyword.php';

      if(this.$route.params.type == 't'){
        reportChartUrl = 'https://www.autoturn.net/api/tiktok/report/report_chart.php';
        reportMaterialChartUrl = 'https://www.autoturn.net/api/tiktok/report/report_material_chart.php';
        reportAgeGenderMaterialChartUrl = 'https://www.autoturn.net/api/tiktok/report/report_age_gender_material_chart.php';
        reportKeywordUrl = 'https://www.autoturn.net/api/tiktok/report/report_keyword.php';
      }

      this.$router.push({ params: { adaccount_id: value }});

      axios
        .post('https://www.autoturn.net/api/adaccount_campaign_list.php', Qs.stringify({
          s_code: this.$route.params.id,
          adaccount_id: value,
          campaign_id: this.$route.params.campaign_id,
          type: this.$route.params.type,
        }))
        .then((listResponse) => {
          // console.log(listResponse.data);
          if(listResponse.data.status == 'success'){
            this.eventOptions = listResponse.data.return_data
            this.eventSelect = listResponse.data.selecded_data

            // console.log('created eventSelect');
            // console.log(this.eventSelect);

            axios
              .post(reportChartUrl, Qs.stringify({
                s_code: this.$route.params.id,
                campaign_id: listResponse.data.selecded_data
              }))
              .then((reResponse) => {
                // console.log(reResponse.data);
                if(reResponse.data.status == 'success'){
                  this.ConditionItem = reResponse.data.condition_item
                  this.displayChartPanel = reResponse.data.chart_panel
                  this.tableData = reResponse.data.info_data
                  this.lineStylesData.datasets = reResponse.data.return_data

                  // console.log('this.lineStylesData.datasets');
                  // console.log(this.lineStylesData.datasets);

                  let select_date_start = reResponse.data.date_start;
                  let select_date_end = reResponse.data.date_end;
                  if(this.$route.params.type == 'tiktok'){
                      if(reResponse.data.select_date_start != '' && reResponse.data.select_date_start != null && typeof reResponse.data.select_date_start != 'undefined'){
                      select_date_start = reResponse.data.select_date_start;
                    }
                    if(reResponse.data.select_date_end != '' && reResponse.data.select_date_end != null && typeof reResponse.data.select_date_end != 'undefined'){
                      select_date_end = reResponse.data.select_date_end;
                    }
                  }

                  this.defaultDateInterval = [new Date(select_date_start), new Date(select_date_end)]

                  this.defaultMinDate = new Date(reResponse.data.date_start)
                  this.defaultMaxDate = new Date(reResponse.data.date_end)

                  this.defaultSettiingDateList = reResponse.data.setting_date
                }

                this.showChartPanel = true;
              });

            axios
              .post(reportMaterialChartUrl, Qs.stringify({
                s_code: this.$route.params.id,
                campaign_id: listResponse.data.selecded_data
              }))
              .then((mchResponse) => {
                // console.log(mchResponse.data);
                if(mchResponse.data.status == 'success'){
                  this.dbHeight = mchResponse.data.height
                  this.materialChartData = mchResponse.data.chart_data
                  // this.materialChartData.labels = mchResponse.data.materialChartData_labels
                  // this.materialChartData.datasets[0].data = mchResponse.data.datasets_data
                  // this.materialChartData.datasets[0].backgroundColor = mchResponse.data.datasets_backgroundColor
                  // this.materialChartData.datasets[0].borderColor = mchResponse.data.datasets_borderColor
                  this.materialChartPrview = mchResponse.data.chart_prview
                  this.materialChartInfo = mchResponse.data.chart_info
                }

                this.showMaterialChartPanel = true;
              });

            axios
              .post(reportAgeGenderMaterialChartUrl, Qs.stringify({
                s_code: this.$route.params.id,
                campaign_id: listResponse.data.selecded_data
              }))
              .then((mchResponse) => {
                // console.log(mchResponse.data);
                if(mchResponse.data.status == 'success'){
                  this.dbAgeGenderHeight = mchResponse.data.height
                  this.ageGenderMaterialChartData = mchResponse.data.chart_data
                  // this.materialChartData.labels = mchResponse.data.materialChartData_labels
                  // this.materialChartData.datasets[0].data = mchResponse.data.datasets_data
                  // this.materialChartData.datasets[0].backgroundColor = mchResponse.data.datasets_backgroundColor
                  // this.materialChartData.datasets[0].borderColor = mchResponse.data.datasets_borderColor
                  this.ageGenderMaterialChartPrview = mchResponse.data.chart_prview
                  this.ageGenderMaterialChartInfo = mchResponse.data.chart_info
                }

                this.showAgeGenderMaterialChartPanel = true;
              });

            axios
              .post(reportKeywordUrl, Qs.stringify({
                s_code: this.$route.params.id,
                campaign_id: listResponse.data.selecded_data
              }))
              .then((reResponse) => {
                // console.log(reResponse.data);

                this.keywordList = reResponse.data.return_data

                // console.log(this.keywordList);

                this.showKeyWord = true;
              });

            this.dbCampaignId = listResponse.data.selecded_data

            // axios
            //   .post('https://www.autoturn.net/api/report/report_log_list.php', Qs.stringify({
            //     s_code: this.$route.params.id,
            //     campaign_id: listResponse.data.selecded_data
            //   }))
            //   .then((reResponse) => {
            //     // console.log(reResponse.data);

            //     this.logData = reResponse.data.return_data

            //     // console.log(this.keywordList);
            //   });
          } else {
            this.ConditionItem = [];
            this.displayChartPanel = [];
            this.tableData = [];
            this.lineStylesData.datasets = [];
            this.defaultDateInterval = [];
            this.keywordList = [];
            this.logData = [];
            this.eventOptions = [];
            this.eventSelect = '';
            this.showChartPanel = true;
            this.showKeyWord = true;
          }
        });
    },
    campaign(value){
      // console.log(value);

      // 開啟綠界刷卡小視窗
      // var iHeight = 700;
      // var iWidth = 1200;
      // //获得窗口的垂直位置
      // var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
      // //获得窗口的水平位置
      // var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
      // var windowStyle = 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=no,titlebar=no';

      // var newWindow = window.open('', 'plan_form_open',windowStyle);
      // document.getElementById('plan_form').submit();

      //單開外網
      // window.open('https://www.google.com.tw', 'fb_service', 'height=600,width=1000');

      //跳出訊息
      // this.$swal('Hello Vue world!!!');

      this.showChartPanel = false;
      this.showMaterialChartPanel = false;
      this.showAgeGenderMaterialChartPanel = false;
      this.showKeyWord = false;

      if(this.fromAccountSelect == 'facebook'){
        axios
          .post('https://www.autoturn.net/api/report/report_chart.php', Qs.stringify({
            s_code: this.$route.params.id,
            campaign_id: value
          }))
          .then((reResponse) => {
            // console.log(reResponse.data);
            if(reResponse.data.status == 'success'){
              this.ConditionItem = reResponse.data.condition_item
              this.displayChartPanel = reResponse.data.chart_panel
              this.tableData = reResponse.data.info_data
              this.lineStylesData.datasets = reResponse.data.return_data

              this.defaultDateInterval = [new Date(reResponse.data.date_start), new Date(reResponse.data.date_end)]

              this.defaultMinDate = new Date(reResponse.data.date_start)
              this.defaultMaxDate = new Date(reResponse.data.date_end)

              this.defaultSettiingDateList = reResponse.data.setting_date
            }

            this.showChartPanel = true;
          });

        axios
          .post('https://www.autoturn.net/api/report/report_material_chart.php', Qs.stringify({
            s_code: this.$route.params.id,
            campaign_id: value
          }))
          .then((mchResponse) => {
            // console.log(mchResponse.data);
            if(mchResponse.data.status == 'success'){
              this.dbHeight = mchResponse.data.height
              this.materialChartData = mchResponse.data.chart_data
              // this.materialChartData.labels = mchResponse.data.materialChartData_labels
              // this.materialChartData.datasets[0].data = mchResponse.data.datasets_data
              // this.materialChartData.datasets[0].backgroundColor = mchResponse.data.datasets_backgroundColor
              // this.materialChartData.datasets[0].borderColor = mchResponse.data.datasets_borderColor
              this.materialChartPrview = mchResponse.data.chart_prview
              this.materialChartInfo = mchResponse.data.chart_info
            }

            this.showMaterialChartPanel = true;
          });

        axios
          .post('https://www.autoturn.net/api/report/report_age_gender_material_chart.php', Qs.stringify({
            s_code: this.$route.params.id,
            campaign_id: value
          }))
          .then((mchResponse) => {
            // console.log(mchResponse.data);
            if(mchResponse.data.status == 'success'){
              this.dbAgeGenderHeight = mchResponse.data.height
              this.ageGenderMaterialChartData = mchResponse.data.chart_data
              // this.materialChartData.labels = mchResponse.data.materialChartData_labels
              // this.materialChartData.datasets[0].data = mchResponse.data.datasets_data
              // this.materialChartData.datasets[0].backgroundColor = mchResponse.data.datasets_backgroundColor
              // this.materialChartData.datasets[0].borderColor = mchResponse.data.datasets_borderColor
              this.ageGenderMaterialChartPrview = mchResponse.data.chart_prview
              this.ageGenderMaterialChartInfo = mchResponse.data.chart_info
            }

            this.showAgeGenderMaterialChartPanel = true;
          });

        axios
          .post('https://www.autoturn.net/api/report/report_keyword.php', Qs.stringify({
            s_code: this.$route.params.id,
            campaign_id: value
          }))
          .then((reResponse) => {
            // console.log(reResponse.data);

            this.keywordList = reResponse.data.return_data

            // console.log(this.keywordList);

            this.showKeyWord = true;
          });


      } else {
        axios
          .post('https://www.autoturn.net/api/tiktok/report/report_chart.php', Qs.stringify({
            s_code: this.$route.params.id,
            campaign_id: value
          }))
          .then((reResponse) => {
            // console.log(reResponse.data);
            if(reResponse.data.status == 'success'){
              this.ConditionItem = reResponse.data.condition_item
              this.displayChartPanel = reResponse.data.chart_panel
              this.tableData = reResponse.data.info_data
              this.lineStylesData.datasets = reResponse.data.return_data

              let select_date_start = reResponse.data.date_start;
              let select_date_end = reResponse.data.date_end;
              if(reResponse.data.select_date_start != '' && reResponse.data.select_date_start != null && typeof reResponse.data.select_date_start != 'undefined'){
                select_date_start = reResponse.data.select_date_start;
              }
              if(reResponse.data.select_date_end != '' && reResponse.data.select_date_end != null && typeof reResponse.data.select_date_end != 'undefined'){
                select_date_end = reResponse.data.select_date_end;
              }

              this.defaultDateInterval = [new Date(select_date_start), new Date(select_date_end)]

              this.defaultMinDate = new Date(reResponse.data.date_start)
              this.defaultMaxDate = new Date(reResponse.data.date_end)

              this.defaultSettiingDateList = reResponse.data.setting_date
            }

            this.showChartPanel = true;
          });

        axios
          .post('https://www.autoturn.net/api/tiktok/report/report_material_chart.php', Qs.stringify({
            s_code: this.$route.params.id,
            campaign_id: value
          }))
          .then((mchResponse) => {
            // console.log(mchResponse.data);
            if(mchResponse.data.status == 'success'){
              this.dbHeight = mchResponse.data.height
              this.materialChartData = mchResponse.data.chart_data
              // this.materialChartData.labels = mchResponse.data.materialChartData_labels
              // this.materialChartData.datasets[0].data = mchResponse.data.datasets_data
              // this.materialChartData.datasets[0].backgroundColor = mchResponse.data.datasets_backgroundColor
              // this.materialChartData.datasets[0].borderColor = mchResponse.data.datasets_borderColor
              this.materialChartPrview = mchResponse.data.chart_prview
              this.materialChartInfo = mchResponse.data.chart_info
            }

            this.showMaterialChartPanel = true;
          });

        axios
          .post('https://www.autoturn.net/api/tiktok/report/report_age_gender_material_chart.php', Qs.stringify({
            s_code: this.$route.params.id,
            campaign_id: value
          }))
          .then((mchResponse) => {
            // console.log(mchResponse.data);
            if(mchResponse.data.status == 'success'){
              this.dbAgeGenderHeight = mchResponse.data.height
              this.ageGenderMaterialChartData = mchResponse.data.chart_data
              // this.materialChartData.labels = mchResponse.data.materialChartData_labels
              // this.materialChartData.datasets[0].data = mchResponse.data.datasets_data
              // this.materialChartData.datasets[0].backgroundColor = mchResponse.data.datasets_backgroundColor
              // this.materialChartData.datasets[0].borderColor = mchResponse.data.datasets_borderColor
              this.ageGenderMaterialChartPrview = mchResponse.data.chart_prview
              this.ageGenderMaterialChartInfo = mchResponse.data.chart_info
            }

            this.showAgeGenderMaterialChartPanel = true;
          });

        axios
          .post('https://www.autoturn.net/api/tiktok/report/report_keyword.php', Qs.stringify({
            s_code: this.$route.params.id,
            campaign_id: value
          }))
          .then((reResponse) => {
            // console.log(reResponse.data);

            this.keywordList = reResponse.data.return_data

            // console.log(this.keywordList);

            this.showKeyWord = true;
          });

        this.showMaterialChartPanel = true;
        this.showAgeGenderMaterialChartPanel = true;
      }

      this.dbCampaignId = value

      // axios
      //   .post('https://www.autoturn.net/api/report/report_log_list.php', Qs.stringify({
      //     s_code: this.$route.params.id,
      //     campaign_id: value
      //   }))
      //   .then((reResponse) => {
      //     // console.log(reResponse.data);

      //     this.logData = reResponse.data.return_data

      //     // console.log(this.keywordList);
      //   });
    },
    setCalendarMainShow(){
      var todayForm = new Date();
      var yearForm = todayForm.getFullYear();
      var dateForm = String(todayForm.getDate()).padStart(2, '0');
      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

      todayForm = yearForm + monthForm + dateForm + timeForm;

      this.toCalendarMainShow = 'false_'+todayForm;
    }
  },
  mounted () {
    // document.title = '分析報表頁 - AutoTurn';
  }
}

</script>

<style lang="scss" scoped>
.downer-block {
  height: 40vw;
}
::v-deep .apexcharts-menu-item.exportCSV {
  display: none;
}
</style>